import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { BehaviorSubject, auditTime, map, startWith, switchMap } from 'rxjs';
import { AsyncPipe } from '@angular/common';

import { BlockService, ConfigService, SafeHtmlPipe, StoreService } from '@speedy/core';

@Component({
  standalone: true,
  selector: 'app-block',
  template: `<div
    class="block-item"
    [innerHTML]="(block$ | async)?.content! | safeHtml"
  ></div>`,
  imports: [AsyncPipe, SafeHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockComponent {
  private readonly blockService = inject(BlockService);
  private readonly configService = inject(ConfigService);
  private readonly storeService = inject(StoreService);

  @Input() set identifier(identifier: string) {
    if (identifier) {
      this.identifier$.next(identifier);
    }
  }

  identifier$ = new BehaviorSubject<string>('');

  block$ = this.storeService.store$.pipe(
    auditTime(0),
    startWith(this.storeService.getCurrentStore()),
    switchMap(() => this.identifier$),
    switchMap((identifier) => this.getBlock(identifier)),
  );

  getBlock(identifier: string) {
    return this.blockService.getBlockByIdentifier(identifier).pipe(
      map((block) => {
        if (block) {
          const mediaUrl = this.configService.mediaUrl;
          const content = block.content
            ?.replace(/src="\/media\//g, `src="${mediaUrl}`)
            ?.replace(/\/pub\/media\//g, '/media/');

          return { ...block, content };
        } else {
          return {
            content: '',
          };
        }
      }),
    );
  }
}
